import axios from '../../../utils/axios'

export default {
    getTrainings () {
        return axios.get('/training')
            .then(response => {
                return response.data
            })
    },

    getTraining (id) {
        return axios.get('/training/' + id)
            .then(response => {
                return response.data
            })
    },

    createTraining (data) {
        return axios.post('/training', data)
    },

    updateTraining (id, data) {
        return axios.put('/training/' + id, data)
    },

    deleteTraining (id) {
        return axios.delete('training/' + id)
    },

    getTeachers () {
        return axios.get('/training/Teacher')
            .then(response => {
                return response.data
            })
    },

}
